// import firebase from "firebase";

// const firebaseApp = firebase.initializeApp({
//   // copy and paste your firebase credential here
//     apiKey: "AIzaSyATnTT7-DpO-WQg3WO1SzMvYD9nYEsVB1A",
//     authDomain: "fima-d6bf5.firebaseapp.com",
//     projectId: "fima-d6bf5",
//     storageBucket: "fima-d6bf5.appspot.com",
//     messagingSenderId: "303522894551",
//     appId: "1:303522894551:web:923465908813ca3e8cd692",
//     measurementId: "G-WJ1DBJ04W5"
// });

// const db = firebaseApp.firestore();

// export { db };
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  // copy and paste your firebase credential here
  apiKey: "AIzaSyATnTT7-DpO-WQg3WO1SzMvYD9nYEsVB1A",
  authDomain: "fima-d6bf5.firebaseapp.com",
  projectId: "fima-d6bf5",
  storageBucket: "fima-d6bf5.appspot.com",
  messagingSenderId: "303522894551",
  appId: "1:303522894551:web:923465908813ca3e8cd692",
  measurementId: "G-WJ1DBJ04W5"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const firestore = firebase.firestore();

export const generateUserDocument = async (user, additionalData) => {
  if (!user) return;

  const userRef = firestore.doc(`users/${user.uid}`);
  const snapshot = await userRef.get();

  if (!snapshot.exists) {
    const { email, displayName } = user;
    try {
      await userRef.set({
        displayName,
        email,
        ...additionalData
      });
    } catch (error) {
      console.error("Error creating user document", error);
    }
  }
  return getUserDocument(user.uid);
};

export const getUserDocument = async uid => {
  if (!uid) return null;
  try {
    const userDocument = await firestore.doc(`users/${uid}`).get();

    return {
      uid,
      ...userDocument.data()
    };
  } catch (error) {
    console.error("Error fetching user", error);
  }
};

export const getRecipe = async recipeId => {
  if (!recipeId) return null;
  try {
    const recipeDocument = await firestore.doc(`mini_recipes/${recipeId}`).get();

    return {
      recipeId,
      ...recipeDocument.data()
    };
  } catch (error) {
    console.error("Error fetching recipe", error);
  }
};

export const setLikedDb = async (uid, recipeId, likeClicked) => {
  if (!recipeId) return null;

  const userRef = firestore.doc(`users/${uid}`);
  const snapshot = await userRef.get();

  try {
    // if user has liked at least ten recipes, 
    // let's also update their list of recommendations by calling the cloud function
    if (likeClicked === true) {
      userRef.update({
       liked: firebase.firestore.FieldValue.arrayUnion(recipeId),
       disliked: firebase.firestore.FieldValue.arrayRemove(recipeId)
      });
    } else {
      userRef.update({
        liked: firebase.firestore.FieldValue.arrayRemove(recipeId)
      });
    }

  } catch (error) {
    console.error("Error liking recipe", error);
  }
};

export const setDislikedDb = async (uid, recipeId, dislikeClicked) => {
  if (!recipeId) return null;

  const userRef = firestore.doc(`users/${uid}`);
  const snapshot = await userRef.get();

  try {

    if (dislikeClicked === true) {
      userRef.update({
        liked: firebase.firestore.FieldValue.arrayRemove(recipeId),
        disliked: firebase.firestore.FieldValue.arrayUnion(recipeId),
      });
    } else {
      userRef.update({
        disliked: firebase.firestore.FieldValue.arrayRemove(recipeId)
      });
    }    


  } catch (error) {
    console.error("Error disliking recipe", error);
  }
};

export const updateRecipes = async (uid, recipeIdsNew) => {
  if (!recipeIdsNew) return null;

  const userRef = firestore.doc(`users/${uid}`);
  const snapshot = await userRef.get();

  try {
      userRef.update({
        recipeIds: recipeIdsNew
      });
  
  } catch (error) {
    console.error("Error updating recipes", error);
  }
};